import { computed, onMounted } from 'vue'
import { useRecipeStore } from '@/stores/recipeStore.js'
import { DateTime } from 'luxon'

export default {
  name: 'RecipeDetail',
  props: ['id'],
  setup(props) {
    const recipeStore = useRecipeStore() // Assuming you have a recipe store defined
    const recipeId = props.id

    const recipe = computed(() => {
      return recipeStore.recipe
    })

    onMounted(async () => {
      await recipeStore.fetchRecipeById(recipeId)
    })

    function getNiceDate(date) {
      if (!date) return ''
      const dt = DateTime.fromJSDate(new Date(date))
      return dt.toFormat('dd.MM.yyyy HH:mm')
    }

    return {
      getNiceDate,
      recipeId,
      recipe,
    }
  },
}
